import { createReducer, createAction } from '@reduxjs/toolkit'

export interface MotorbikeModelsReducer {
  models: string[]
  brandId: number | null
  loading: boolean
}

const initialState: MotorbikeModelsReducer = {
  models: [],
  brandId: null,
  loading: false
}

export const FETCH_MOTORBIKE_MODELS = createAction<number>('motorbike_models_reducer/fetch_motorbike_models')
export const FETCH_MOTORBIKE_MODELS_SUCCESS = createAction<string[]>(
  'motorbike_models_reducer/fetch_motorbike_models_success'
)
export const FETCH_MOTORBIKE_MODELS_FAILURE = createAction('motorbike_models_reducer/fetch_motorbike_models_failure')
export const CLEAR_MOTORBIKE_MODELS = createAction('motorbike_models_reducer/clear_motorbike_models')

export const motorbikeModelsReducer = createReducer(initialState, (builder) => {
  builder.addCase(FETCH_MOTORBIKE_MODELS, (state, action) => {
    return { ...state, loading: true, brandId: action.payload }
  })
  builder.addCase(FETCH_MOTORBIKE_MODELS_SUCCESS, (state, action) => {
    return { ...state, models: action.payload, loading: false }
  })
  builder.addCase(FETCH_MOTORBIKE_MODELS_FAILURE, (state) => {
    return { ...state, models: [], loading: false }
  })
  builder.addCase(CLEAR_MOTORBIKE_MODELS, () => {
    return initialState
  })
})
